import React, { useEffect, useState } from "react";
import {
    fetchCities,
    fetchCountries,
    createCity,
    deleteCity
} from "../api/cityService";

const CityPage = () => {
    const [cities, setCities] = useState([]);
    const [countries, setCountries] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const [form, setForm] = useState({
        name: "",
        countryId: ""
    });

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            setLoading(true);
            const [cits, ctrs] = await Promise.all([
                fetchCities(),
                fetchCountries(),
            ]);

            setCities(Array.isArray(cits) ? cits : []);
            setCountries(Array.isArray(ctrs) ? ctrs : []);
        } catch (e) {
            console.error(e);
            setError("Failed to load data");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        try {
            if (!form.name || !form.countryId) {
                setError("All fields are required");
                return;
            }

            await createCity({
                name: form.name,
                countryId: Number(form.countryId)
            });

            setSuccess("City created");
            setForm({ name: "", countryId: "" });
            await loadData();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error creating city");
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this city?")) return;

        try {
            await deleteCity(id);
            setSuccess("City deleted");
            await loadData();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error deleting city");
        }
    };

    if (loading) return <div className="p-4">Loading...</div>;

    return (
        <div className="p-6 max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold mb-4">Cities & Countries</h2>

            {error && <div className="text-red-500 mb-3">{error}</div>}
            {success && <div className="text-green-600 mb-3">{success}</div>}

            {/* CREATE FORM */}
            <form onSubmit={handleCreate} className="mb-6 space-y-2">
                <input
                    type="text"
                    name="name"
                    placeholder="City name"
                    value={form.name}
                    onChange={handleChange}
                    className="border p-2 w-full rounded"
                />

                <select
                    name="countryId"
                    value={form.countryId}
                    onChange={handleChange}
                    className="border p-2 w-full rounded"
                >
                    <option value="">Select country</option>
                    {countries.map((c) => (
                        <option key={c.id} value={c.id}>
                            {c.name}
                        </option>
                    ))}
                </select>

                <button className="bg-blue-600 text-white px-4 py-2 rounded">
                    Add City
                </button>
            </form>

            {/* LIST */}
            <ul className="space-y-2">
                {cities.map((city) => {
                    const country = countries.find(c => c.id === city.countryId);

                    return (
                        <li
                            key={city.id}
                            className="flex justify-between border p-3 rounded"
                        >
                            <span>
                                {city.name} ({country?.name || "�"})
                            </span>

                            <button
                                onClick={() => handleDelete(city.id)}
                                className="text-red-600"
                            >
                                Delete
                            </button>
                        </li>
                    );
                })}
            </ul>

            {cities.length === 0 && (
                <p className="text-gray-500 mt-4">No cities found</p>
            )}
        </div>
    );
};

export default CityPage;